import React, { Fragment } from 'react'
import { ResponsiveSVG } from 'ui/acro'

import Introductory from '../../images/introductory.svg'
import Beginner from '../../images/beginner.svg'
import Intermediate from '../../images/intermediate.svg'
import Advanced from '../../images/advanced.svg'
import Moderate from '../../images/moderate.svg'
import TreeIcon from '../../images/latest/tree.svg'

import I1 from '../../images/intensity-1.svg'
import I2 from '../../images/intensity-2.svg'
import I3 from '../../images/intensity-3.svg'
import I4 from '../../images/intensity-4.svg'
import { capitalize } from 'components_v2/common'

export const difficultyIconMap = {
  introductory: Introductory,
  moderate: Moderate,
  advanced: Advanced,
  beginner: Beginner,
  intermediate: Intermediate
}

export const intensityIconMap = {
  1: I1,
  2: I2,
  3: I3,
  4: I4
}

export const IntensityContainer = ({ intensityLevel }) => {
  return (
    <>
      {intensityLevel && (
        <div className='intensity-section'>
          <h4>Intensity</h4>
          <div className='intensity plan-stats'>
            <div className='icon'>
              <ResponsiveSVG
                SVG={intensityIconMap[String(intensityLevel)]}
                width='13px'
                height='13px'
                className='codicon'
              />
            </div>
            <div className='desc'>Intensity {intensityLevel}</div>
          </div>
        </div>
      )}
    </>
  )
}

export const StyleSection = ({ categories }) => {
  return (
    <div className='difficulty-section'>
      <h4>STYLE</h4>
      <div className='plan-stats duration'>
        <div className='icon'>
          <ResponsiveSVG SVG={TreeIcon} width='20px' height='20px' />
        </div>

        <div className='category-subcategory-list'>
          {categories?.map((category) => (
            <Fragment key={category.id}>
              <span className='category-name'>{category.title}</span>
              <div className='subcategory-container'>
                {category?.subcategories
                  ?.filter((i) => i.slug !== 'single-classes')
                  ?.map((sub) => (
                    <div key={sub.id} className='subcategory-card'>
                      {sub?.title}
                    </div>
                  ))}
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

export const DifficultyContainer = ({ difficultyLevel }) => {
  return (
    <>
      {difficultyLevel && (
        <div className='difficulty-section'>
          <h4>Difficulty</h4>
          <div className='difficulty plan-stats'>
            <div className='icon'>
              <ResponsiveSVG
                SVG={difficultyIconMap[difficultyLevel]}
                width='13px'
                className='codicon'
                height='13px'
              />
            </div>
            <div className='desc'> {capitalize(difficultyLevel)}</div>
          </div>
        </div>
      )}
    </>
  )
}
